import firebase from "../../config/firebase";
import algoliasearch from "algoliasearch";
import { createNullCache } from "@algolia/cache-common";
import { toast } from "react-toastify";
const client = algoliasearch("GPYJEAVUBP", "b1f999bc5b264defe930762391d240c6", {
  responsesCache: createNullCache(),
});

export const getRestaurantsAction = (restaurantID) => async (dispatch) => {
  dispatch(restaurantLoader(true));
  try {
    firebase
      .firestore()
      .collection("users")
      .where("type", "==", "restaurant")
      .where("restaurantID", "==", restaurantID)
      .onSnapshot(async (query) => {
        let temp = [];
        for (let doc of query.docs) {
          temp.push({ id: doc.id, ...doc.data() });
        }

        dispatch({ type: "GET_RESTAURANT_DATA", payload: temp[0] });
        dispatch(restaurantLoader(false));
      });
  } catch (err) {
    dispatch(restaurantLoader(false));
    toast.error(err.message);
  }
};

export const getAllMerchantAction = (id, category) => async (dispatch) => {
  try {
    dispatch(restaurantLoader(true));
    firebase
      .firestore()
      .collection("users")
      .where("type", "==", "restaurant")
      .where("subScriptionStatus", "==", "subscribe")
      .orderBy("createdAt", "desc")
      .onSnapshot(async (query) => {
        let allRestaurants = [];
        for (let doc of query.docs) {
          if (doc.exists) {
            const restaurantData = doc.data();
            if (
              restaurantData.storeTiming &&
              restaurantData.storeTiming !== "" &&
              restaurantData.location &&
              restaurantData.location !== "" &&
              restaurantData.storeTiming?.some(
                (timing) => timing.startTime && timing.endTime
              )
            ) {
              allRestaurants.push({
                id: doc.id,
                ...restaurantData,
              });
            }
          }
        }
        dispatch({ type: "GET_ALL_MERCHANT", payload: allRestaurants });
        dispatch(restaurantLoader(false));
      });
  } catch (err) {
    dispatch(restaurantLoader(false));
    console.error(err.message);
  }
};

export const updateMerchant = (id, obj, onSuccess) => async (dispatch) => {
  dispatch(restaurantUpdateLoader(true));
  try {
    await firebase.firestore().collection("users").doc(id).update(obj);
    onSuccess();
    dispatch({
      type: "UPDATE_RESTAURANT",
      payload: { id, ...obj },
    });
    dispatch(restaurantUpdateLoader(false));
  } catch (err) {
    console.error("Error updating merchant:", err);
    dispatch(restaurantUpdateLoader(false));
    toast.error("Error updating merchant. Please try again.");
  }
};

export const deleteRestaurant = (id, onSuccess) => async (dispatch) => {
  dispatch(restaurantDeleteLoader(true));
  firebase
    .firestore()
    .collection("users")
    .doc(id)
    .delete()
    .then(() => {
      onSuccess();
      dispatch({ type: "DELETE_RESTAURANT", payload: id });
      dispatch(restaurantDeleteLoader(false));
    })
    .catch((err) => {
      console.error("Error deleting restaurant:", err);
      dispatch(restaurantDeleteLoader(false));
      toast.error("Error deleting restaurant. Please try again.");
    });
};

export const getAllRestaurant =
  (search, hitsPerPage, currentPage, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch(restaurantLoader(true));
    const index = client.initIndex("users");
    index
      .search(search, {
        filters: "type:restaurant",
        hitsPerPage: hitsPerPage,
        page: currentPage,
      })
      .then((response) => {
        let { hits, ...rest } = response;
        dispatch({
          type: "GET_RESTAURANT",
          payload: hits,
        });
        dispatch({ type: "RESTAURANT_DETAILS", payload: rest });
        dispatch(restaurantLoader(false));
        onSuccess();
      });
  };

export const addBackground =
  (ID, mode, file, onSuccess = () => {}) =>
  async (dispatch) => {
    const fileName = file?.name;
    const fileName1 = fileName.split(".")[0];
    const fileName2 = fileName1.toLowerCase();

    const storageRef = firebase
      .storage()
      .ref("restaurant_BG/")
      .child(fileName2);
    const existingFileRef = firebase
      .storage()
      .ref()
      .child(`restaurant_BG/${fileName2}`);
    try {
      await existingFileRef.getDownloadURL();
      await existingFileRef.delete();
    } catch (error) {
      console.error(error);
    }
    await storageRef.put(file);
    const urlFeatured = await storageRef.getDownloadURL();

    if (mode === "dark") {
      await firebase.firestore().collection("users").doc(ID).update({
        customerDarkBG: urlFeatured,
      });
    } else {
      await firebase.firestore().collection("users").doc(ID).update({
        customerBG: urlFeatured,
      });
    }

    onSuccess();
  };

export const deleteBG =
  (obj, onSuccess = () => {}, onError = () => {}) =>
  async (dispatch) => {
    const { restaurantID, type, imageUrl } = obj;
    try {
      if (type === "light") {
        firebase.firestore().collection("users").doc(restaurantID).update({
          customerBG: "",
        });
      } else {
        firebase.firestore().collection("users").doc(restaurantID).update({
          customerDarkBG: "",
        });
      }
      const storage = firebase.storage();
      const urlParts = imageUrl.split("?")[0].split("/");
      const filePath = decodeURIComponent(urlParts[urlParts.length - 1]);

      const fileRef = storage.ref().child(filePath);

      await fileRef.delete();
      onSuccess();
    } catch (error) {
      onError();
      console.error("Error deleting file:", error);
    }
  };

const restaurantLoader = (data) => async (dispatch) => {
  dispatch({
    type: "RESTAURANT_LOADER",
    payload: data,
  });
};

const restaurantDeleteLoader = (data) => async (dispatch) => {
  dispatch({
    type: "RESTAURANT_DELETE_LOADER",
    payload: data,
  });
};

const restaurantUpdateLoader = (data) => async (dispatch) => {
  dispatch({
    type: "RESTAURANT_UPDATE_LOADER",
    payload: data,
  });
};

export const getPlatFormFeedbacks = (Count) => async (dispatch) => {
  try {
    dispatch(feedbackLoader(true));

    const querySnapshot = await firebase
      .firestore()
      .collection("platformFeedback")
      .limit(Count + 1)
      .orderBy("createdAt", "desc")
      .get();

    if (querySnapshot.empty) {
      dispatch(feedbackLoader(false));
      dispatch({ type: "PLATFORM_FEEDBACKS", payload: [] });
      dispatch({ type: "SET_HAS_MORE_FEEDBACKS", payload: false });
      return;
    }

    const feedbacks = await Promise.all(
      querySnapshot.docs.map(async (doc) => {
        try {
          const data = doc.data();
          const userPromise = firebase
            .firestore()
            .collection("users")
            .doc(data.userID)
            .get();
          const restaurantPromise = firebase
            .firestore()
            .collection("users")
            .doc(data.restaurantID)
            .get();

          const [userDoc, restaurantDoc] = await Promise.all([
            userPromise,
            restaurantPromise,
          ]);

          return {
            id: doc.id,
            name: userDoc.exists ? userDoc.data().name : "Unknown User",
            email: userDoc.exists ? userDoc.data().email : "Unknown Email",
            restaurantName: restaurantDoc.exists
              ? restaurantDoc.data().name
              : "Unknown Restaurant",
            ...data,
          };
        } catch (error) {
          console.error("Error processing feedback doc:", error);
          return null;
        }
      })
    );

    const filteredFeedbacks = feedbacks.filter(Boolean);

    const hasMore = filteredFeedbacks.length > Count;

    const feedbacksToReturn = hasMore
      ? filteredFeedbacks.slice(0, Count)
      : filteredFeedbacks;

    dispatch(feedbackLoader(false));
    dispatch({
      type: "PLATFORM_FEEDBACKS",
      payload: feedbacksToReturn,
    });
    dispatch({ type: "SET_HAS_MORE_FEEDBACKS", payload: hasMore });
  } catch (error) {
    dispatch(feedbackLoader(false));
    dispatch({ type: "SET_HAS_MORE_FEEDBACKS", payload: false });
    console.error("Error fetching platform feedbacks:", error);
  }
};

const feedbackLoader = (data) => async (dispatch) => {
  dispatch({
    type: "FEEDBACK_LOADER",
    payload: data,
  });
};
